// Brand-safe card accent presets. Each value is an HSL triplet (no hsl() wrapper)
// so it can be assigned to CSS custom properties consumed via hsl(var(--fc-accent)).
export const CARD_ACCENTS = {
  copper: { label: "Copper", h: "28 63% 48%", h2: "32 72% 60%", swatch: "#C9772E" },
  blue: { label: "Deep Blue", h: "210 70% 34%", h2: "205 64% 48%", swatch: "#1B4F86" },
  teal: { label: "Teal", h: "188 52% 33%", h2: "184 48% 45%", swatch: "#1F7A86" },
  forest: { label: "Forest", h: "158 42% 33%", h2: "150 38% 45%", swatch: "#2F7A5E" },
  gold: { label: "Gold", h: "42 66% 44%", h2: "44 74% 56%", swatch: "#BE8C1E" },
  crimson: { label: "Crimson", h: "354 52% 45%", h2: "356 55% 56%", swatch: "#B23A43" },
  plum: { label: "Plum", h: "318 33% 42%", h2: "320 36% 54%", swatch: "#8E4A78" },
  slate: { label: "Slate", h: "214 18% 42%", h2: "214 16% 54%", swatch: "#5A6B7E" },
};

export const DEFAULT_ACCENT = "copper";

export function accentVars(key) {
  const a = CARD_ACCENTS[key] || CARD_ACCENTS[DEFAULT_ACCENT];
  return { "--fc-accent": a.h, "--fc-accent-2": a.h2 };
}
